export enum Path {
  partnerAvailability = 'partners/availability',
  detailCoupons = 'manage/coupons/detail',
  addCoupons = 'manage/coupons/create',
  editService = 'manage/services/add',
  allEarning = 'vendor-all-earning',
  detailService = 'manage/services/detail',
  detailComplaint = 'complains/detail',
  detailComboPackage = 'manage/combo-packages/detail',
  editComboPackage = 'manage/combo-packages/create',
  detailComboBooking = 'combo-booking/detail',
  detailCustomer = 'customers/details',
  detailLocation = 'manage/locations/details',
  detailRefundManagment = 'refund-management/detail',
  detailChatManagment = 'chat/detail',
  chatListing = 'chat/list',
  serviceList = 'manage/services',
  locationList = 'manage/locations',
  complainsList = 'complains',
  bookingList = 'bookings',
  refundList = 'refund-management',
  leadList = 'leads',
  comboPackage = 'combo-packages',
  comboBooking = 'combo-booking',
  addPlan = 'manage/plans/create',
}

export enum StorageKeys {
  config = 'config',
}

export enum RequiredPersonalInformation {
  emiratesId = 'emiratesId',
  passport = 'passport',
  emiratesIdAndPassport = 'emiratesIdAndPassport',
  none = 'none',
}

export enum AdrenalineMeterScale {
  low = 'low',
  average = 'average',
  high = 'high',
}

export enum CategoryType {
  vehchleForGroup = 'vehchleForGroup',
  shared = 'shared',
  single = 'single',
  group = 'group',
}

export enum ServiceStatus {
  pending = 'pending',
  approved = 'approved',
  declined = 'declined',
  disabled = 'disabled',
}

export enum LeadStatus {
  pending = "pending",
  converted = "converted",
  declined = "declined"
}

export enum ComplaintStatus {
  initiated = 'initiated',
  inReview = 'inReview',
  resolved = 'resolved',
  declined = "declined"
}
